import { Button } from "react-bootstrap";
import styled from "styled-components";
import { colors, types } from "../../../libs";

export const NoTicketContainer = styled.div`
  display: flex;
  justify-content: flex-start; 
  align-items: center;
  height: 60vh; 
  width: 100%;
  padding-left: 20px;
`;

export const NoTicketCard = styled.div`
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  text-align: left; 
  background: ${colors.background.black};
  padding: 20px;
  margin: 20px 0px;
  border: 1px solid ${colors.background.lightWhite};
  width: 100%;
`;

export const NoTicketTitle = styled.h3`
  ${types.headers.small}
  margin-bottom: 5px;
  margin: 10px 0;
`;

export const NoTicketDescription = styled.p`
   ${types.body.subtitle}
  margin-bottom: 15px;
  color:${colors.text.lightGray};
`;

export const NewTicketButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px; 
  padding: 13px 12px;
  img {
    width: 20px;
    height: 20px;
  }
`;

export const Icon = styled.img`
  width: 20px;
  height: 20px;
`;